@import '../../style/index';

@include host {
  rcm-icon {
    position: absolute;
    top: 0;
    right: 0;
    width: rem-calc(56px);
    height: rem-calc(56px);
    background: var(--colors-dark-base);
    border: none;
    color: var(--colors-basic-white);
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;

    @include breakpoint($large) {
      width: rem-calc(61px);
      height: rem-calc(61px);
    }
  }

  .choices {
    &__inner {
      display: flex;
      align-items: center;
      border-radius: 0;
      border: 1px solid var(--colors-grey-base);
      font-family: $font-family-regular;
      width: calc(100% - var(--spacings-s) * 2);
      font-size: rem-calc(16px);
      height: rem-calc(56px);

      @include breakpoint($large) {
        height: rem-calc(61px);
      }
    }

    &__item {
      color: var(--colors-dark-base);
    }

    &:focus {
      outline: 1px solid var(--colors-raiffeisen-blue);
    }
  }

  .is-open .choices__list--dropdown {
    border-color: var(--colors-grey-base);

    @include layer-priority-top();

    .choices__item--selectable {
      &::after {
        content: '';
      }

      @media (width >= 640px) {
        padding-right: 10px;
      }
    }
  }

  .choices__list--single {
    & .choices__item {
      white-space: nowrap;
    }
    vertical-align: text-top;
  }

  .input_wrapper {
    position: relative;
    width: auto;

    &--small {
      .choices {
        height: rem-calc(28px);

        &__inner {
          width: calc(100% - 28px);
          font-size: rem-calc(12px);
          line-height: rem-calc(12px);
          min-height: 0;
          height: rem-calc(28px);
          display: flex;
          align-items: center;
          justify-content: center;
          pointer-events: none;

          @include breakpoint($large) {
            height: rem-calc(28px);
          }
        }

        &__list--single {
          padding: rem-calc(5px);
          vertical-align: center;
        }
      }

      .is-open .choices__list--dropdown {
        .choices__item {
          padding: rem-calc(5px);
          font-size: rem-calc(12px);
        }
      }

      rcm-icon {
        width: rem-calc(28px);
        height: rem-calc(28px);

        @include breakpoint($large) {
          width: rem-calc(28px);
          height: rem-calc(28px);
        }
      }
    }
  }

  .small-dropdown {
    .choices__list--dropdown .choices__list {
      height: 150px;
    }
  }

  label {
    display: block;
    margin: var(--spacings-xs) 0;
    font-size: rem-calc(14px);
    font-family: $font-family-semibold;

    @include breakpoint($large) {
      font-size: rem-calc(16px);
    }
  }
}
